import React from 'react'
import { useOutletContext } from 'react-router-dom'

import { SecuritySettingsOutletCtx } from '../SecuritySettings.page'
import { TwoFactorAuthentication } from './TwoFactorAuthentication'

export const TwoFactorAuthPage: React.FC = () => {
  const {
    activeProviders,
    twoFAProvidersTypes,
    twoFAProvidersActionTypes,
    onProviderToggle,
    onAuthActionsProviderToggle,
    onPhoneNumberChange,
    onGenerateRecoveryCodes,
    isTwoFAProvidersLoading,
    account,
  } = useOutletContext<SecuritySettingsOutletCtx>()

  return (
    <TwoFactorAuthentication
      onPhoneNumberChange={onPhoneNumberChange}
      providers={twoFAProvidersTypes}
      activeProviders={activeProviders}
      twoFAProvidersActionTypes={twoFAProvidersActionTypes}
      onProviderToggle={onProviderToggle}
      onAuthActionsProviderToggle={onAuthActionsProviderToggle}
      onGenerateRecoveryCodes={onGenerateRecoveryCodes}
      account={account}
      isTwoFAProvidersLoading={isTwoFAProvidersLoading}
    />
  )
}
